import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Typography, Theme } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { MY_MENU } from 'shared/constants/menu-constants';
import { urls } from 'shared/constants/routing.constants';
import { DIALOG_SING_OUT } from 'shared/constants/modal-constants';
import { useLoading } from 'shared/hooks/useLoading';
import { useCommonDialog } from 'shared/hooks/useCommonDialog';
import { useLogoutMutation } from 'redux/api/auth.api';
import { TAlertDialog } from 'shared/types/card.interface';

interface HeaderContextMenuProps {
  contextMenuIsOpen: boolean;
  handlerClick: (dialogInfo: TAlertDialog, isLogout?: boolean) => void;
}

interface MenuData {
  name: string;
  dialogInfo: TAlertDialog;
  isLogout?: boolean;
  icon?: ReactNode;
}

const HeaderContextMenu: React.FC<HeaderContextMenuProps> = ({
  contextMenuIsOpen,
  handlerClick,
}) => {
  const navigate = useNavigate();

  const [logout, { isLoading: isLoadingLogout }] = useLogoutMutation();
  useLoading(isLoadingLogout);

  const logoutMenuDialog: TAlertDialog = {
    title: DIALOG_SING_OUT.title,
    text: DIALOG_SING_OUT.text,
    сonsentText: DIALOG_SING_OUT.сonsentText,
    dissentText: DIALOG_SING_OUT.dissentText,
    сonsentCallback: () => {
      navigate(urls.commonPages.home);
      logout();
    },
  };

  const menuData: MenuData[] = [
    {
      name: MY_MENU.MyChallenges,
      dialogInfo: useCommonDialog(urls.myPages.myChallenges),
    },
    {
      name: MY_MENU.MyDebates,
      dialogInfo: useCommonDialog(urls.myPages.myDebates),
    },
    {
      name: MY_MENU.Profile,
      dialogInfo: useCommonDialog(urls.myPages.profile),
    },
    // { name: MY_MENU.Help, url: urls.myPages.help, dialogInfo: commonMenuDialog },
    {
      name: MY_MENU.SignOut,
      dialogInfo: logoutMenuDialog,
      isLogout: true,
      icon: (
        <LogoutIcon
          sx={{
            transform: 'scaleX(-1)',
            fontSize: '20px',
            marginRight: '12px',
          }}
        />
      ),
    },
  ];

  return contextMenuIsOpen ? (
    <Stack
      direction="column"
      sx={{
        top: 70,
        right: 30,
        position: 'absolute',
        width: '208px',
        maxHeight: '215px',
        borderRadius: '12px',
        backgroundColor: 'primary.contrastText',
        boxShadow: (theme: Theme) => `0 2px 24px 0 ${theme.palette.myShadow.menu}`,
        zIndex: 5,
      }}
    >
      {menuData.map((menuItem, index) => (
        <Stack
          key={index}
          onClick={() => handlerClick(menuItem.dialogInfo, menuItem.isLogout)}
          direction="row"
          sx={{
            alignItems: 'center',
            padding: '13px 54px 14px 16px',
            transition: 'background-color ease-in-out 0.2s',
            cursor: 'pointer',
            '&[data-first="true"]': {
              borderTopLeftRadius: '12px',
              borderTopRightRadius: '12px',
            },
            '&[data-last="true"]': {
              borderBottomLeftRadius: '12px',
              borderBottomRightRadius: '12px',
            },
            '&:hover': {
              backgroundColor: 'myGrey.grey100',
            },
          }}
        >
          {menuItem.icon}

          <Typography variant="h6" color="primary.main">
            {menuItem.name}
          </Typography>
        </Stack>
      ))}
    </Stack>
  ) : null;
};

export default HeaderContextMenu;
